import { Stack, Typography, useTheme } from "@mui/material";
import { useFeatureFlags } from "components/providers/featureFlags/useFeatureFlags";
import { T } from "components/util/t";
import { Section } from "./HomePage";
import { EVENT_CARD_WIDTH, EventCard } from "./eventCard/EventCard";
import { ScrollWithShadows } from "components/layout/utils/ScrollWithShadows";
import { EventCardMainSection } from "./eventCard/EventCardMainSection";
import { RecentlyViewedEvent, RecentlyViewedEventDivision, useRecentlyViewed } from "./useRecentlyViewed";
import { EventCardTitle } from "./eventCard/EventCardTitle";
import { EventCardDate } from "./eventCard/EventCardDate";
import { EventStatusPill } from "components/layout/event/EventStatusPill";
import { eventCardDate } from "models/Event";
import { EventCardOrganisation } from "./eventCard/EventCardOrganisation";
import { Link } from "react-router-dom";
import { isTeamFormat } from "utils/utils";


export const RecentlyViewed: React.FC = () => {
    const isFeatureToggleOn = useFeatureFlags("Recently Viewed");
    const theme = useTheme();
    const { items: recentlyViewed } = useRecentlyViewed();

    if (!isFeatureToggleOn || recentlyViewed.length === 0) return null;

    const eventCartdWidth = parseInt(theme.spacing(EVENT_CARD_WIDTH));
    const eventCardPadding = parseInt(theme.spacing(2));
    const eventCardWidthPadding = eventCartdWidth + eventCardPadding;

    return(
        <Section marginTop={4}>
            <Typography variant="h3" component="h3">
                <T>Recently Viewed</T>
            </Typography>
            <ScrollWithShadows shadowsColor="background.default" showButtons buttonsPositionAbsolute fixedScrollOffset={eventCardWidthPadding}>
                {recentlyViewed.map((item, index) => item.type === "event" ?
                    <RecentlyViewedEventCard event={item} key={index} /> : <RecentlyViewedEventDivisionCard eventDivision={item} key={index} />
                )}
            </ScrollWithShadows>
        </Section>
    );
};

const RecentlyViewedEventCard: React.FC<{event: RecentlyViewedEvent}> = ({ event }) =>
    <Link to={`/events/${event.id}`} aria-label={event.name}>
        <EventCard sx={{ width: 440 }}>
            <EventCardMainSection status={event.status}>
                <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                    <EventCardDate date={eventCardDate(event, { shortFormat: true })} />
                    <EventStatusPill status={event.status} />
                </Stack>
                <EventCardTitle title={event.name} />
            </EventCardMainSection>
            <EventCardOrganisation organisation={event.organisation} logo={true} status={event.status} />
        </EventCard>
    </Link>;

const RecentlyViewedEventDivisionCard: React.FC<{eventDivision: RecentlyViewedEventDivision}> = ({ eventDivision }) => {
    const baseLink = `/events/${eventDivision.event.id}/divisions/${eventDivision.eventDivisionId || eventDivision.id}`;
    return (
        <Link to={baseLink} aria-label={eventDivision.division.name}>
            <EventCard sx={{ width: 440 }}>
                <EventCardMainSection>
                    <EventCardDate date={eventDivision.event.name} />
                    <EventCardTitle title={eventDivision.division.name} />
                    <Stack direction="row" spacing={0.5} alignItems="center" data-testid="event-card-location">
                        <div>
                            <T count={eventDivision.entryCount}>
                                {isTeamFormat(eventDivision.formatDefinition) ? "team_count" : "athlete_count"}
                            </T>
                        </div>
                    </Stack>
                </EventCardMainSection>
            </EventCard>
        </Link>
    );
};
